var Backbone = require('backbone')
  , _ = require('underscore')


function createElement() {
  if (typeof document.createElement !== 'function') {
    // This is the case in IE7, where the type of createElement is "object".
    // For this reason, we cannot call apply() as Object is not a Function.
    return document.createElement(arguments[0]);
  } else {
    return document.createElement.apply(document, arguments);
  }
}

module.exports = {
  hasPushState: _.memoize(function() {
    return !! (window.history && window.history.pushState)
  })
, hasHashChange: _.memoize(function() {
    return ('onhashchange' in window
      && (document.documentMode === void 0 || document.documentMode > 7))
  })
, supportCanvas: _.memoize(function() {
    var elem = createElement('canvas')
    return !!(elem.getContext && elem.getContext('2d'));
  })
, isWexinQQBrowser: _.memoize(function() {
    var ua = navigator.userAgent.toLowerCase()
    return /(micromessenger|QQ\/)/i.test(ua)
  })
, isWexinBrowser: _.memoize(function() {
    var ua = navigator.userAgent
    return /micromessenger/i.test(ua)
  })
, isAndroid: _.memoize(function() {
    var ua = navigator.userAgent
    return /Android/i.test(ua)
  })
, isiOS: _.memoize(function() {
    var ua = navigator.userAgent
    return /iPhone|iPad|iPod/i.test(ua)
  })
, isMobile: _.memoize(function() {
    var ua = navigator.userAgent
    return /Android|webOS|iPhone|iPod|BlackBerry|Windows Phone/i.test(ua)
  })
, checkOpen: function(cb) {
    var _clickTime = +(new Date());
    function check(elsTime) {
      if (elsTime > 3000 || document.hidden || document.webkitHidden) {
        cb(1);
      } else {
        cb(0);
      }
    }
    //启动间隔20ms运行的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
    var _count = 0, intHandle;
    intHandle = setInterval(function () {
      _count++;
      var elsTime = +(new Date()) - _clickTime;
      if (_count >= 100 || elsTime > 3000) {
        clearInterval(intHandle);
        check(elsTime);
      }
    }, 20);
  }
}
